module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Image/pendingLeaderBoard-5f2a8db3ebb9b210c1a74b7c456d61a0.svg";